import { useEffect, useRef } from "react";
import type { FieldValues, UseFormWatch } from "react-hook-form";

export function useContentChange<TForm extends FieldValues, TContent>(
  watch: UseFormWatch<TForm>,
  onChange: (content: TContent) => void,
  toContent: (values: TForm) => TContent,
) {
  const latest = useRef({ onChange, toContent });
  latest.current = { onChange, toContent };

  useEffect(() => {
    const subscription = watch(values =>
      latest.current.onChange(latest.current.toContent(values as TForm)),
    );
    return () => subscription.unsubscribe();
  }, [watch]);
}
